var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-1356 -471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3038",
    "data-name": "Rectangle 3038",
    width: 24,
    height: 24,
    transform: "translate(1356 471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34103",
    "data-name": "Path 34103",
    d: "M88.054,9.787l1.911-1.911h0a.547.547,0,0,0,0-.773L87.141,4.279a.547.547,0,0,0-.773,0L84.457,6.19ZM83.172,7.475,70.12,20.527V23.9h0a.219.219,0,0,0,.219.219h3.382L86.769,11.071Z",
    transform: "translate(1287.877 468.881)",
    fill: "#797979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ad9253389b550b7af84c8683941440d1.svg";
export { ForwardRef as ReactComponent };